import { supabase } from "@/integrations/supabase/client";

export async function updateOrganizationChatBackground(
  organizationId: string,
  chatBackground: string
): Promise<void> {
  try {
    const { error } = await supabase
      .from("organizations")
      .update({ chat_background: chatBackground })
      .eq("id", organizationId);

    if (error) {
      throw error;
    }
  } catch (error) {
    console.error("Error updating organization chat background:", error);
    throw error;
  }
} 